<template>
  <div class="brief_wrapper" :style="`background-color: ${background}`">
    <div class="brief_content content_wrapper" :style="`flex-direction: ${isReverse ? `row-reverse` : `row`}`">
      <div class="intro_content">
        <h3>{{ briefData.title }}</h3>
        <div class="intro_item" v-for="(item, index) in briefData.introItems" :key="item.id">
          <h4 v-if="item.subtitle">{{ item.subtitle }}</h4>
          <p v-if="item.intro">{{ item.intro }}</p>
        </div>

        <div class="apply_btn" v-if="hasButton">
          <button>申请试用</button>
        </div>
      </div>
      <div class="img_content">
        <img :src="briefData.imgSrc" alt="intro_img" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isReverse: {
      type: Boolean,
      default: false,
    },
    hasButton: {
      type: Boolean,
      default: false,
    },
    briefData: {
      type: Object,
    },
    background: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.brief_wrapper {
  width: 100%;
  background-color: #fff;
  padding: 70px 0px;
  .brief_content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .intro_content {
      width: 480px;
      h3 {
        font-size: 24px;
        font-weight: 400;
        color: #0d0e24;
        margin-bottom: 50px;
      }
      .intro_item {
        margin-bottom: 50px;
        h4 {
          font-size: 16px;
          font-weight: 400;
          color: #0d0e24;
          margin-bottom: 10px;
          line-height: 25px;
        }
        p {
          font-size: 14px;
          font-weight: 300;
          color: #6e6e66;
          line-height: 20px;
        }
      }
      .apply_btn {
        width: 110px;
        height: 34px;
        button {
          width: 100%;
          height: 100%;
          font-size: 14px;
          color: #ffffff;
          background: #4173fb;
          border-radius: 17px;
        }
      }
    }
    .img_content {
      width: 500px;
      img {
        max-width: 100%;
      }
    }
  }
}
</style>